import { useState } from 'react';
import type { AccountTaskActionQuestion } from '@shared/types/task-actions';
import { Button } from '@/components/ui/Button';

export const TaskActionQuestion = ({ question, onAnswer }: {
  question: AccountTaskActionQuestion;
  onAnswer: (answer: { key: string; value: string }) => void;
}) => {
  const [value, setValue] = useState('');
  return <form className="space-y-3" onSubmit={event => {
    event.preventDefault();
    if (value.trim()) onAnswer({ key: question.key, value: value.trim() });
  }}>
    <p className="text-sm">{question.prompt}</p>
    {question.inputMode === 'single_select' ? <div className="grid gap-2">{question.options.map(option =>
      <Button key={option.value} type="button" variant="secondary" onClick={() => onAnswer({ key: question.key, value: option.value })}>{option.label}</Button>
    )}</div> : <>
      <input aria-label={question.prompt} value={value} onChange={event => setValue(event.target.value)} maxLength={320} required className="w-full rounded-lg border border-domino-cardBorder p-3 text-sm" />
      <Button type="submit">Continuer</Button>
    </>}
  </form>;
};
